import React, { useRef } from 'react';
import { ContentSurface } from 'apis/CompanyAPI/tracking/types';
import usePostImpression from 'hooks/usePostImpression';

interface Props {
  contentId: string;
  surface: ContentSurface;
  className?: string;
  children: React.ReactNode;
}

/** Wraps a post card in a list of posts and logs an impression once it has been on screen */
export default function PostImpression({ contentId, surface, className, children }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  usePostImpression(contentId, ref, surface);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
